import WIDGETS from './widgets';

export default {
	name: 'broadcast_message_actions',
	spacing: 2,
	sx: { width: '100%' },
	widgets: [{ content: WIDGETS.BROADCAST_MESSAGE_ACTIONS, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
